import horizontalScroll from "../modules/horizontalScroll.js";

let scrollPos = window.scrollY || document.documentElement.scrollTop;

const initBlock = function( block ) {
	const $section = $( block );
	const formId = $section.find( ".nf-form-cont" ).attr( "id" );
	const iframe = $section.find( "iframe" );

	if ( !formId ) {return;}

	$( document ).on( "nfFormSubmitResponse", function( event, response ) {
		if ( `nf-form-${response?.id}-cont` === formId ) {
			$section.find( "[data-first-step-form]" ).hide();
			let scrollHeight = $section.find( "[data-second-step-form]" ).first().offset().top;
			let headerHeight = 0;
			let adminbarHeight = 0;

			if ( $( ".section-header" ).length ) {
				headerHeight = $( ".section-header" ).outerHeight();
			}

			if ( $( "#wpadminbar" ).length ) {
				adminbarHeight = $( "#wpadminbar" ).outerHeight();
			}

			$( "html, body" ).animate( {
				scrollTop: scrollHeight - headerHeight - adminbarHeight - 30
			}, 500 );
		}
	} );

	function preventScrollToIframe( e ) {
		e.preventDefault();
		e.stopPropagation();
		window.scrollTo( {
			top: scrollPos,
			left: 0,
			behavior: "instant",
		} );
	}

	iframe[0].onload = function() {
		$( window ).on( "scroll", preventScrollToIframe );

		setTimeout( () => {
			$( window ).off( "scroll", preventScrollToIframe );
		}, 2000 );
	};

	horizontalScroll( block );
};

themeUtils.loadBlock( initBlock, "submit-an-application", ".section-submit-an-application" );
